import Body from "./Body";
import Footer from "./Footer";

const Home=()=>{
    return (
        <div>
            <Body/>
            <Footer/>
        </div>
        );
    }

export default Home;